import { Button, Modal } from 'antd';
import { useCallback, useEffect, useState } from 'react';

type NoticeListModalProps = {
  visible: boolean;
  onClose?: Function;
  setVisible: Function;
};

export default function NoticeListModal({ visible, onClose, setVisible }: NoticeListModalProps) {
  const [hasForceUnreadNotice, setHasForceUnreadNotice] = useState<boolean>(true);

  useEffect(() => {
    window.addEventListener('message', handleForceUnreadNoticeCallback);
    return () => {
      window.removeEventListener('message', handleForceUnreadNoticeCallback);
    };
  }, []);

  function handleForceUnreadNoticeCallback(res) {
    const eventName = res.data?.eventName;
    const value = res.data?.value;
    if (eventName === 'hasForceUnreadNoticeCallback') {
      setHasForceUnreadNotice(value);
    }
  }

  const handleClose = useCallback(() => {
    setVisible(false);
    onClose?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      title="公告提醒"
      visible={visible}
      onCancel={handleClose}
      centered={true}
      className="notice-list-modal"
      width="1000px"
      closable={false}
      maskClosable={false}
      footer={[
        <Button
          disabled={hasForceUnreadNotice}
          key="close"
          title={hasForceUnreadNotice ? '阅读公告后才可关闭' : '关闭'}
          onClick={handleClose}
        >
          关闭
        </Button>,
      ]}
    >
      <iframe
        frameBorder="0"
        width="100%"
        height="580px"
        style={{ overflow: 'hidden' }}
        src="/sso/notice-list?inIframe=1"
      />
      <style jsx>{`
        :global(.notice-list-modal .ant-modal-body) {
          padding: 0;
        }
      `}</style>
    </Modal>
  );
}
